import React, { useState } from "react";
import "./popupack.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useTranslation } from "react-i18next";

const PopupAckdispatchedinfo = ({ status, handleClose }) => {

  const { i18n, t } = useTranslation();
  return (
    <div className="popupackconatiners">
      <div className="img-para"><img src={Image_Url.CROSSPOP} onClick={handleClose} /></div>
      <div className="popupackfirst-para">
        <span className="popupackfirst-para-span">{t('parts_list_ack.dispatchdetail')}</span>
      </div>
      <div className="popupacksecond-para">
        <span className="popuack-second-para">{t('partorderlist.message')}</span>
      </div>
      <div className="popupackthird-para ">
        <textarea className="text-area-box" name="remark" value={status} readOnly > </textarea>
      </div>
      <div className="popup-button-container">
        <button className="acknowledge-buttons-pop" onClick={handleClose} >
        {t('saveconfirmationpopup.ok')}
        </button>
      </div>

    </div>
  );
};

export default  PopupAckdispatchedinfo;
